import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
const savedTheme = localStorage.getItem("theme") || "light";
document.documentElement.setAttribute("data-theme", savedTheme);
createRoot(document.getElementById("root")).render(<App />);
